"use strict";$(document).ready((function(){$(document).on("click",".ets_wa_whatsapp_block a",(function(e){/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)&&(e.preventDefault(),window.location.href=$(this).data("mobile-href"))}))}));
//# sourceMappingURL=front.js.map
